import type { CommentSubjectRef, CommentSubjectType } from "./types";

export abstract class BaseCommentSubjectAdapter {
	abstract readonly subjectType: CommentSubjectType;

	getSubjectRef(subjectId: string): CommentSubjectRef {
		// Subject adapters keep entity-specific wiring out of the shared comments panel.
		return {
			subjectType: this.subjectType,
			subjectId,
		};
	}

	getEmptyStateTitle(): string {
		return "No comments yet";
	}

	getEmptyStateDescription(): string {
		return "Start the conversation.";
	}
}

export class ProjectCommentSubjectAdapter extends BaseCommentSubjectAdapter {
	readonly subjectType = "project" as const;
}

export const projectCommentSubjectAdapter = new ProjectCommentSubjectAdapter();
